import React from 'react';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useHygieneServiceResponsible } from '../_hooks/useHygieneServiceResponsible';
import type { FormItemProps } from '@/components/views/Resolution886/types';

export function ResponsibleHygieneServiceFormItem({ fieldName = '' }: Readonly<FormItemProps>): JSX.Element {
	const { isLoading, data, addItem, handleSearch, handleInputChange } = useHygieneServiceResponsible({ fieldName });

	return (
		<FormItem
			required
			name={fieldName}
			label="Responsible for the Hygiene Service and Security"
			requiredMessage="Please select a responsible for the hygiene service and security"
		>
			<Select.Multiple
				isAdd
				isSingle
				options={data}
				textButton="Add"
				addItem={addItem}
				loading={isLoading}
				onSearch={handleSearch}
				onInputChange={handleInputChange}
				placeholder="Select a responsible"
				placeholderInput="Please enter a responsible"
			/>
		</FormItem>
	);
}
